import {LatLngBoundsExpression} from "leaflet";

export const CARTO_API_KEY = "cb1_3jcd_1_458fdb82c67081f7ae50d17e";

export const THUNDERFOREST_API_KEY = "836fffe965a64f1684547f7d7a51822e";

export const THEMES = {
  LIGHT: 'LIGHT',
};

export const LINK_PRIVACY = "https://www.iubenda.com/privacy-policy/87466855"

export const LINK_COOKIE_POLICY = "https://www.iubenda.com/privacy-policy/87466855/cookie-policy"

export const LINK_TERMS = "https://www.iubenda.com/termini-e-condizioni/87466855"

export const WSS_URL = "wss://hub.retemet.com/mqtt"

export const WSS_CENTRALINE_REAL_TIME = "ws/#"

export const WSS_MTRACKER_REAL_TIME = "mtracker/#"

export const WSS_MISTRAL_REAL_TIME ="mistral/#"

export const WSS_OMIRL_REAL_TIME ="omirl/#"

export const WSS_IDROMETRI = "device/TRF001"
export const dimensioniMarker = 30
export const EXPIRING_TIME_CENTRALINA = 30


export const LIGURIA: LatLngBoundsExpression = [
  [43.6587, 7.5602],
  [44.7412, 10.1365],
]

// ID delle stazioni meteo OMIRL ammesse nella mappa statica. Gli idrometri sono già inclusi.
export const STATIC_MAP_OMIRL_DEVICE_IDS: number[] = [];
